import React from "react";
import styled from "styled-components";
import { ProductConsumer } from "../../context";
import AdminProduct from "./AdminProduct";
import { Link } from "react-router-dom";

export default function AdminControlPanel(product) {
	return (
		<ProductConsumer>
			{(value) => {
				const {filteredProducts,handleLogout} = value;
				
				
				return (
					<AdminControlPanelWrapper className="container">
					
                        <h2 className="h1-responsive font-weight-bold text-center my-4">Welcome admin </h2>

                        <section>
                        <div className="container">
						<Link to='/adminaddproduct' className='main-link' style={{margin:'0.75rem'}}>Tilføj produkt</Link>	
						<button onClick={handleLogout} className='main-link' style={{margin:'0.75rem'}}>logout</button>	

				
							<div className="row py-5">
								{filteredProducts.length === 0 ? (
									<div className="col text-title text-center">
										sorry, no items matched your search
									</div>
								) : (
									filteredProducts.map((product) => {
										return <AdminProduct key={product.nr} product={product} />;
									})
								)}
							</div>
						</div>
                   
                        </section>

                                        </AdminControlPanelWrapper>
                                    );
                                }}
							
		</ProductConsumer>
	);
}

const AdminControlPanelWrapper = styled.div`
	height:100vh;
`;
